import { formatDateTime, formatDate } from '@ninja/utilities';

const getDateFormatter = (viewMode, enableTimeSelection) => {
    switch (viewMode) {
        case 'time':
            return (date, options) => formatDate(date, Object.assign(Object.assign({}, options), { dateFormat: 'HH:mm' }));
        case 'months':
            return (date, options) => formatDate(date, Object.assign(Object.assign({}, options), { dateFormat: 'MM/yyyy' }));
        case 'years':
            return (date, options) => formatDate(date, Object.assign(Object.assign({}, options), { dateFormat: 'yyyy' }));
        case 'days':
        default:
            return enableTimeSelection ? formatDateTime : formatDate;
    }
};

export { getDateFormatter };
